import z from "zod/v4";

import { NodeTypeSchema } from "./nodes/base-node";
import { ExecutionMetricsSchema } from "./execution-metrics";
import { ExecutionErrorSchema } from "./node-execution";

export const SessionStepSchema = z.object({
  workflowId: z.string(),
  id: z.string(),
  userId: z.string(),
  orgId: z.string(),
  sessionId: z.string(),
  nodeId: z.string(),
  nodeType: NodeTypeSchema,
  timestamp: z.number(),
  input: z.unknown().optional(),
  output: z.unknown().optional(),
  error: ExecutionErrorSchema.optional(),
  metrics: ExecutionMetricsSchema.optional(),
});

export type SessionStep = z.infer<typeof SessionStepSchema>;

export const CreateSessionStepSchema = SessionStepSchema.partial({
  orgId: true,
  userId: true,
  timestamp: true,
});

export type CreateSessionStep = z.infer<typeof CreateSessionStepSchema>;
